<div class="page-title-bar">
  <h1
    class="page-title"
    [attr.aria-labelledby]="pageTitle + 'Title'"
    [id]="pageTitle + '_title'"
    [attr.data-pw]="pageTitle + '_title'"
    [attr.data-qa]="pageTitle + '_title'">
    {{ pageTitle }}
  </h1>
</div>

<div class="page-outer-container">
  <div class="record-edit-card">
    <header class="record-edit-header">
      <h2
        class="record-edit-title"
        [attr.aria-labelledby]="title + 'Title'"
        [id]="title + '_title'"
        [attr.data-pw]="title + '_title'"
        [attr.data-qa]="title + '_title'">
        {{ title }}
      </h2>
    </header>

    <form [formGroup]="form" class="record-edit-body" >
      @for (section of sections; track trackBySection($index, section)) {
        <div class="record-edit-section">
          <h3
            class="record-edit-section-title"
            [attr.aria-labelledby]="prefix + '_' + section.title + 'Title'"
            [id]="prefix + '_' + section.title + '_title'"
            [attr.data-pw]="prefix + '_' + section.title + '_title'"
            [attr.data-qa]="prefix + '_' + section.title + '_title'">
            {{ section.title }}
          </h3>
          <div class="record-edit-fields-row">
            @for (field of section.fields; track trackByField($index, field)) {
              @if (isVisible(field)) {
                <div class="record-edit-field">
                  <label
                    [for]="field.key"
                    [attr.aria-label]="field.label"
                    [id]="field.key + 'Label'"
                    class="record-edit-label"
                    [attr.data-pw]="prefix + '_' + field.key + '_label'"
                    [attr.data-qa]="prefix + '_' + field.key + '_label'">
                    {{ field.label }}
                  </label>

                  @switch (field.type) {
                    @case ('boolean') {
                      @if (isReadonly(field)) {
                        <span
                          class="record-view-value"
                          [id]="prefix + '_' + field.key + '_value'"
                          [attr.data-pw]="prefix + '_' + field.key + '_value'"
                          [attr.data-qa]="prefix + '_' + field.key + '_value'">
                          {{ displayValue(field) }}
                        </span>
                      } @else {
                        <mat-select
                          panelClass="record-edit-select-panel"
                          [id]="field.key"
                          [formControlName]="field.key"
                          [placeholder]="field.label"
                          [attr.aria-labelledby]="field.key + 'Label'"
                          [attr.aria-describedby]="errorId(field)"
                          [attr.data-pw]="prefix + '_' + field.key + '_select'"
                          [attr.data-qa]="prefix + '_' + field.key + '_select'">
                          @for (option of getOptions(field); track option.value) {
                            <mat-option [value]="option.value">{{ option.label }}</mat-option>
                          }
                        </mat-select>
                      }
                    }
                    @case ('select') {
                      @if (isReadonly(field)) {
                        <span
                          class="record-view-value"
                          [id]="prefix + '_' + field.key + '_value'"
                          [attr.data-pw]="prefix + '_' + field.key + '_value'"
                          [attr.data-qa]="prefix + '_' + field.key + '_value'">
                          {{ displayValue(field) }}
                        </span>
                      } @else {
                        <mat-select
                          panelClass="record-edit-select-panel"
                          [id]="field.key"
                          [formControlName]="field.key"
                          [placeholder]="field.label"
                          [attr.aria-labelledby]="field.key + 'Label'"
                          [attr.aria-describedby]="errorId(field)"
                          [attr.data-pw]="prefix + '_' + field.key + '_select'"
                          [attr.data-qa]="prefix + '_' + field.key + '_select'" >
                          @for (option of getOptions(field); track option.value) {
                            <mat-option [value]="option.value">{{ option.label }}</mat-option>
                          }
                        </mat-select>
                      }
                    }
                    @case ('search-select') {
                      @if (isReadonly(field)) {
                        <span
                          class="record-view-value"
                          [id]="prefix + '_' + field.key + '_value'"
                          [attr.data-pw]="prefix + '_' + field.key + '_value'"
                          [attr.data-qa]="prefix + '_' + field.key + '_value'">
                          {{ displayValue(field) }}
                        </span>
                      } @else {
                        <cfi-searchable-select
                          variant="plain"
                          panelClass="record-edit-select-panel"
                          [controlId]="field.key"
                          [formControlName]="field.key"
                          [options]="getOptions(field)"
                          [selectedOption]="selectedOptionFor(field)"
                          [placeholder]="field.label"
                          [ariaLabelledBy]="field.key + 'Label'"
                          [ariaDescribedBy]="errorId(field)"
                          [testPrefix]="prefix + '_' + field.key"
                          testSeparator="_" />
                      }
                    }
                    @case ('date') {
                      <div class="record-edit-date-wrapper">
                        <input
                          [id]="field.key"
                          [matDatepicker]="picker"
                          [formControlName]="field.key"
                          [attr.aria-labelledby]="field.key + 'Label'"
                          [attr.aria-describedby]="errorId(field)"
                          [attr.aria-invalid]="isInvalid(field)"
                          [attr.aria-required]="isRequired(field)"
                          [attr.data-pw]="prefix + '_' + field.key + '_input'"
                          [attr.data-qa]="prefix + '_' + field.key + '_input'"
                          placeholder="MM/DD/YYYY"
                          readonly
                          (click)="picker.open()" />
                        <mat-icon
                          class="record-edit-date-icon"
                          (click)="picker.open()"
                          tabindex="0"
                          (keydown.enter)="picker.open()"
                          aria-label="Open date picker"
                          >calendar_today</mat-icon
                        >
                        <mat-datepicker #picker />
                      </div>
                    }
                    @case ('autocomplete') {
                      @if (isReadonly(field)) {
                        <span
                          class="record-view-value"
                          [id]="prefix + '_' + field.key + '_value'"
                          [attr.data-pw]="prefix + '_' + field.key + '_value'"
                          [attr.data-qa]="prefix + '_' + field.key + '_value'">
                          {{ displayValue(field) }}
                        </span>
                      } @else {
                        <div class="record-edit-autocomplete-wrapper">
                          <input
                            type="text"
                            [id]="field.key"
                            [formControlName]="field.key"
                            [matAutocomplete]="fieldAuto"
                            [placeholder]="field.label"
                            [attr.aria-labelledby]="field.key + 'Label'"
                            [attr.aria-describedby]="errorId(field)"
                            [attr.aria-invalid]="isInvalid(field)"
                            [attr.aria-required]="isRequired(field)"
                            [attr.data-pw]="prefix + '_' + field.key + '_input'"
                            [attr.data-qa]="prefix + '_' + field.key + '_input'"
                            class="record-edit-autocomplete-input" />
                          <mat-autocomplete
                            #fieldAuto="matAutocomplete"
                            [displayWith]="displayWith">
                            @if (field.optionsKey && searching[field.optionsKey]) {
                              <mat-option disabled>
                                <span class="record-edit-autocomplete-loading"><mat-spinner diameter="16" /> Searching…</span>
                              </mat-option>
                            } @else if (!getOptions(field).length && hasSearchQuery(field)) {
                              <mat-option disabled>No matches found</mat-option>
                            } @else {
                              @for (option of getOptions(field); track option.value) {
                                <mat-option [value]="option">{{ option.label }}</mat-option>
                              }
                            }
                          </mat-autocomplete>
                        </div>
                      }
                    }
                    @case ('currency') {
                      <input
                        type="number"
                        step="0.01"
                        [id]="field.key"
                        [formControlName]="field.key"
                        [readonly]="isReadonly(field)"
                        [attr.aria-readonly]="isReadonly(field) ? true : null"
                        [attr.aria-labelledby]="field.key + 'Label'"
                        [attr.aria-describedby]="errorId(field)"
                        [attr.aria-invalid]="isInvalid(field)"
                        [attr.aria-required]="isRequired(field)"
                        [placeholder]="field.label"
                        [attr.data-pw]="prefix + '_' + field.key + '_input'"
                        [attr.data-qa]="prefix + '_' + field.key + '_input'" />
                    }
                    @case ('number') {
                      <input
                        type="number"
                        step="1"
                        [id]="field.key"
                        [formControlName]="field.key"
                        [readonly]="isReadonly(field)"
                        [attr.aria-readonly]="isReadonly(field) ? true : null"
                        [attr.aria-labelledby]="field.key + 'Label'"
                        [attr.aria-describedby]="errorId(field)"
                        [attr.aria-invalid]="isInvalid(field)"
                        [attr.aria-required]="isRequired(field)"
                        [placeholder]="field.label"
                        [attr.data-pw]="prefix + '_' + field.key + '_input'"
                        [attr.data-qa]="prefix + '_' + field.key + '_input'" />
                    }
                    @default {
                      <input
                        type="text"
                        [id]="field.key"
                        [formControlName]="field.key"
                        [readonly]="isReadonly(field)"
                        [attr.aria-readonly]="isReadonly(field) ? true : null"
                        [attr.aria-labelledby]="field.key + 'Label'"
                        [attr.aria-describedby]="errorId(field)"
                        [attr.aria-invalid]="isInvalid(field)"
                        [attr.aria-required]="isRequired(field)"
                        [placeholder]="field.placeholder ?? field.label"
                        (input)="onFormattedInput(field, $event)"
                        [attr.data-pw]="prefix + '_' + field.key + '_input'"
                        [attr.data-qa]="prefix + '_' + field.key + '_input'" />
                    }
                  }

                  @if (errorFor(field); as error) {
                    <span
                      class="record-edit-error"
                      role="alert"
                      [id]="prefix + '_' + field.key + '_error'"
                      [attr.data-pw]="prefix + '_' + field.key + '_error'"
                      [attr.data-qa]="prefix + '_' + field.key + '_error'">
                      {{ error }}
                    </span>
                  }
                </div>
              } @else if (field.hideInEdit) {
                  <input
                    [hidden]="true"
                    [id]="field.key"
                    [formControlName]="field.key"
                    [attr.aria-labelledby]="field.key + 'Label'"
                    [placeholder]="field.label"
                    [attr.data-pw]="prefix + '_' + field.key + '_input'"
                    [attr.data-qa]="prefix + '_' + field.key + '_input'" />
              }
            }
          </div>
        </div>
      }

      <div class="record-edit-footer">
        <button
          mat-stroked-button
          type="button"
          (click)="cancelled.emit()"
          [id]="prefix + '_cancel_button'"
          [attr.data-pw]="prefix + '_cancel_button'"
          [attr.data-qa]="prefix + '_cancel_button'">
          Cancel
        </button>
        <button
          mat-flat-button
          type="button"
          color="primary"
          (click)="save.emit()"
          [disabled]="isSaving"
          [id]="prefix + '_save_button'"
          [attr.data-pw]="prefix + '_save_button'"
          [attr.data-qa]="prefix + '_save_button'">
          @if (isSaving) {
            <mat-spinner diameter="16" style="display: inline-block; margin-right: 8px"></mat-spinner>
          }
          {{ isSaving ? 'Saving...' : 'Save Changes' }}
        </button>
      </div>
    </form>
  </div>
</div>
